export default function NumberFourCircleIcon({
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM15 14.25H14.25V16.5C14.25 16.6989 14.171 16.8897 14.0303 17.0303C13.8897 17.171 13.6989 17.25 13.5 17.25C13.3011 17.25 13.1103 17.171 12.9697 17.0303C12.829 16.8897 12.75 16.6989 12.75 16.5V14.25H9C8.88116 14.25 8.76401 14.2218 8.65822 14.1676C8.55243 14.1135 8.46102 14.035 8.39153 13.9385C8.32204 13.8421 8.27645 13.7306 8.25853 13.6131C8.2406 13.4956 8.25086 13.3756 8.28844 13.2628L10.5384 6.51281C10.6013 6.32409 10.7366 6.16809 10.9146 6.07913C11.0925 5.99017 11.2985 5.97553 11.4872 6.03844C11.6759 6.10134 11.8319 6.23664 11.9209 6.41457C12.0098 6.59249 12.0245 6.79847 11.9616 6.98719L10.0406 12.75H12.75V10.5C12.75 10.3011 12.829 10.1103 12.9697 9.96967C13.1103 9.82902 13.3011 9.75 13.5 9.75C13.6989 9.75 13.8897 9.82902 14.0303 9.96967C14.171 10.1103 14.25 10.3011 14.25 10.5V12.75H15C15.1989 12.75 15.3897 12.829 15.5303 12.9697C15.671 13.1103 15.75 13.3011 15.75 13.5C15.75 13.6989 15.671 13.8897 15.5303 14.0303C15.3897 14.171 15.1989 14.25 15 14.25Z"
      />
    </svg>
  );
}
